import React from 'react';

type Props = {
  size?: number;
  onClick?: () => void;
};

export default function WalletIcon({ size, onClick }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M17.9252 8.72937H17.1217V7.13772C17.1217 6.61058 16.8857 6.11868 16.4735 5.78921C16.0613 5.45975 15.5316 5.33665 15.0167 5.45311L6.6963 7.32161C5.90303 7.49988 5.34882 8.19252 5.34882 9.00571V17.6842C5.34882 18.6358 6.12319 19.4102 7.0748 19.4102H17.9252C18.8768 19.4102 19.6512 18.6358 19.6512 17.6842V10.4559C19.6512 9.50425 18.8768 8.72937 17.9252 8.72937ZM18.6296 17.6842C18.6296 18.0724 18.3139 18.3886 17.9252 18.3886H7.0748C6.68609 18.3886 6.37041 18.0724 6.37041 17.6842V9.00571C6.37041 8.67369 6.59618 8.39122 6.92003 8.31817L15.2409 6.44968C15.4483 6.40217 15.6669 6.45223 15.8355 6.58708C16.0036 6.72142 16.1001 6.92216 16.1001 7.13772V8.72988H8.38909C8.10661 8.72988 7.87829 8.95872 7.87829 9.24068C7.87829 9.52264 8.10661 9.75147 8.38909 9.75147H17.9252C18.3139 9.75147 18.6296 10.0677 18.6296 10.4559V17.6842Z"
        fill="#EEEEEE"
      />
    </svg>
  );
}
